/* istanbul ignore file */

import { MapIcon, MapPin } from "src/app/models/map-pin-model";
import { MAP_DEFAULTS } from '../shared/constants/map-constants';
import { MapLayerEnum } from '../shared/enums';

export class MapSettingsPreviewModel {
    mapLoading = true;
    map: google.maps.Map;
    mapProperties: google.maps.MapOptions = {
        center: MAP_DEFAULTS.DEFAULT_MAP_CENTER,
        zoom: MAP_DEFAULTS.DEFAULT_MAP_ZOOM,
        mapTypeId: MapLayerEnum.RoadMap,
        mapTypeControl: false,
        zoomControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        draggable: false,
    };
    mapPins: MapPin[] = [];
    marker: google.maps.Marker;
    mapIconDataUrl: string;
    mapIcon: MapIcon;
    currentCoordinates: google.maps.LatLng;
    scaledSize: google.maps.Size;
    svg: any = MAP_DEFAULTS.DEFAULT_MAP_PIN_URL;
    svgDocument: Document = null;
}
